export { DatepickerAdapter } from './datepicker-adapter'
export { RadioGroupAdapter } from './radio-group-adapter'
export { TextInputAdapter } from './text-input-adapter'
export { default as HtmlEditorAdapter } from './html-editor-adapter'
export { TextareaAdapter } from './textarea-adapter'
export { CheckboxAdapter } from './checkbox-adapter'
export { SwitchAdapter } from './switch-adapter'
export { SelectAdapter } from './select-adapter'
export { SuggestAdapter } from './suggest-adapter'
export { MultiselectAdapter } from './multiselect-adapter'
export { MultiselectAdapterSimple } from './mutliselect-adapter-simple'
export { SliderAdapter } from './slider-adapter'
export { FileInputAdapter } from './file-input-adapter'
export { StarRatingAdapter } from './start-rating-adapter'
export { AdvancedSliderAdapter } from './advanced-slider-adapter'
export { FormAction, SubmitCallback, SubmitHandler, FormActionPayload, SelectOption } from './types'
export { createFormActionPayload, generateFormData } from './helpers'

export * from './loading-indicator'

export { changeFieldValueMutator } from './final-form-mutators'
export * from './validators'
export * from './pure-select'
export * from './regularExpressions'

import * as fromMultiselectAdapter from './multiselect-adapter'
import * as fromSuggestAdapter from './suggest-adapter'

const fromSuggest = {
  reducer: fromSuggestAdapter.reducer,
  epics: fromSuggestAdapter.epics,
  STORE_ID: fromSuggestAdapter.STORE_ID,
}
const fromMultiselect = {
  reducer: fromMultiselectAdapter.reducer,
  epics: fromMultiselectAdapter.epics,
  STORE_ID: fromMultiselectAdapter.STORE_ID,
}

export type SuggestState = fromSuggestAdapter.State
export type MultiselectState = fromMultiselectAdapter.State

export { fromSuggest, fromMultiselect }



// WEBPACK FOOTER //
// ./src/modules/forms/index.ts